import { useCallback, useEffect, useRef, useState } from "react";
const COOLDOWN_SECONDS = 60;
export function useResendCooldown() {
    const [timeLeft, setTimeLeft] = useState(0);
    const intervalRef = useRef(null);
    const clearTimer = () => {
        if (intervalRef.current !== null) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
    };
    const startCooldown = useCallback(() => {
        clearTimer();
        setTimeLeft(COOLDOWN_SECONDS);
        intervalRef.current = setInterval(() => {
            setTimeLeft((prev) => {
                if (prev <= 1) {
                    clearTimer();
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);
    }, []);
    useEffect(() => () => clearTimer(), []);
    return { startCooldown, timeLeft, isActive: timeLeft > 0 };
}
